export default {
  app: {
    brand: 'Retro Arcade',
    tagline: '怀旧复古经典小游戏',
    pressStart: '▶ PRESS START TO CONTINUE',
    footer: 'Retro Arcade · Built with Vue 3 + Phaser.js',
  },
  nav: {
    home: '首页',
    games: '全部游戏',
    ranks: '排行榜',
    profile: '我的',
    login: '登录',
    logout: '退出',
    register: '注册',
  },
  home: {
    featured: '热门推荐',
    released: '已上线',
    coming: '即将推出',
    coming_soon: '敬请期待',
    categories: '游戏分类',
    news: '站点公告',
    start: '▶ 开始游戏',
    ranks: '🏆 排行榜',
    play: '▶ 游玩',
    details: '详情',
  },
  games: {
    title: '游戏库 ({count})',
    search: '搜索游戏...',
    all: '全部',
    released: '已上线',
    coming: '即将推出',
    loading: '加载中...',
    no_result: '没有找到匹配的游戏...',
    controls: '操控',
    play: '▶ 游玩',
    lock: '🔒 敬请期待',
    play_disabled: '详情',
    author: '作者: {name}',
  },
  rank: {
    title: '🏆 全站排行榜',
    subtitle: 'TOP PLAYERS - LIVE DATA',
    filter_all: '全部',
    rank: '#',
    user: '玩家',
    game: '游戏',
    score: '分数',
    loading: '▶ 加载中...',
    empty: '还没有人得分,快来抢占榜首!',
    refresh: '刷新',
  },
  profile: {
    title: '👤 个人中心',
    login_first: '请先登录查看个人中心',
    history: '🎮 我的分数 ({count})',
    no_score: '还没有分数,去玩一局吧 ~',
    loading: '📊 加载中...',
    date: '日期',
    score: '分数',
    settings: '⚙ 偏好设置',
    achievements: '🏆 成就: {unlocked}/{total}',
  },
  auth: {
    login_title: 'LOGIN',
    login_sub: 'SIGN IN TO SAVE YOUR PROGRESS',
    register_title: 'REGISTER',
    register_sub: 'CREATE YOUR PLAYER ACCOUNT',
    user: 'USER',
    pass: 'PASS',
    confirm: 'CONFIRM',
    login_btn: '▶ 确认登录',
    register_btn: '▶ 立即注册',
    no_account: '还没账号?',
    has_account: '已有账号?',
    goto_register: '立即注册 →',
    login_success: '登录成功!',
    register_success: '注册成功!正在自动登录...',
  },
  settings: {
    title: '⚙ SETTINGS',
    crt: 'CRT 滤镜(扫描线 + 色散)',
    reduce_motion: '减弱动效( prefers-reduced-motion )',
    pixel_scale: '像素缩放',
    theme: '卡片样式',
    leaderboard_limit: '排行榜默认条数',
    auto_submit: '游戏结束自动提交分数',
    reset: '恢复默认',
  },
  game: {
    exit: '← 退出',
    loading: 'LOADING...',
    error_load: '加载失败',
    back_to_list: '返回游戏库',
    tips: '💡 TIP: 键盘方向键 / WASD 操控 · P 暂停 · R 重开',
    tips_mobile: '移动端请使用下方虚拟按键',
    paused: '⏸ PAUSED',
    continue: '按 P 继续',
    gameover: 'GAME OVER',
    retry: '▶ 再来',
    win: 'YOU WIN!',
    click_retry: '点击重来',
    gameplay: '玩法说明',
    dev_notes: '开发笔记',
  },
  achievements: {
    unlocked: '🏆 成就解锁!',
    first_play: '起步',
    first_play_desc: '第一次游玩 Retro Arcade 的游戏',
    all_games: '全能玩家',
    all_games_desc: '每款游戏都尝试过至少一次',
    rank_top10: '新星玩家',
    rank_top10_desc: '在任意一款游戏拿到排行榜前 10',
    // snake
    snake_novice: '小蛇初长成',
    snake_novice_desc: '贪吃蛇中拿到 50 分',
    snake_skilled: '灵蛇之舞',
    snake_skilled_desc: '贪吃蛇中拿到 150 分',
    snake_master: '蛇王',
    snake_master_desc: '贪吃蛇中拿到 300 分',
    // tetris
    tetris_line: '初识消除',
    tetris_line_desc: 'Tetris 中消除一行',
    tetris_tspin: '连消达人',
    tetris_tspin_desc: 'Tetris 中同时消除 4 行(Tetris)',
    tetris_1k: '千分玩家',
    tetris_1k_desc: 'Tetris 中拿到 1000 分',
    // flappy
    flappy_first: '初飞',
    flappy_first_desc: 'Flappy Bird 首次飞行',
    flappy_10: '百公里',
    flappy_10_desc: 'Flappy Bird 拿到 10 分',
    flappy_50: '翱翔天际',
    flappy_50_desc: 'Flappy Bird 拿到 50 分',
    // 2048
    '2048_128': '小有所成',
    '2048_128_desc': '合成 128',
    '2048_512': '策略家',
    '2048_512_desc': '合成 512',
    '2048_2048': '2048 达成',
    '2048_2048_desc': '合成 2048,胜利!',
    // minesweeper
    mine_clear_easy: '排雷新手',
    mine_clear_easy_desc: '扫雷简单难度获胜',
    mine_clear_medium: '排雷能手',
    mine_clear_medium_desc: '扫雷中等难度获胜',
    mine_clear_hard: '排雷大师',
    mine_clear_hard_desc: '扫雷困难难度获胜',
  },
  not_found: {
    title: '404',
    subtitle: 'PAGE NOT FOUND',
    desc: '你走到了游戏地图之外...',
    back: '▶ 返回主页',
  },
  date: {
    just_now: '刚刚',
    minutes_ago: '{n} 分钟前',
    hours_ago: '{n} 小时前',
    days_ago: '{n} 天前',
  },
}
